import { hasPermission, hasAllPermissions, hasRole } from '@utils/permissions';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const usePermission = () => {
  const { permissions, roles } = useSelector((state) => state.permission);
  const { user } = useSelector((state) => state.auth);

  const userPermissions = useMemo(
    () => (permissions.length ? permissions : user?.permissions || []),
    [permissions, user],
  );

  const userRoles = useMemo(() => (roles.length ? roles : user?.roles || []), [roles, user]);

  return {
    permissions: userPermissions,
    roles: userRoles,
    can: (permission) => hasPermission(userPermissions, permission),
    canAll: (required) => hasAllPermissions(userPermissions, required),
    hasRole: (role) => hasRole(userRoles, role),
  };
};

export default usePermission;
